/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Private Flags API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    RulesView,
    RulesViewFromJSON,
    RulesViewToJSON,
} from '../models';

export interface ListRulesRequest {
    project_id: number;
    environment_key: string;
    per_page?: number;
    page_token?: string;
    page_window?: number;
    rule_types?: string;
    sort?: Array<ListRulesSortEnum>;
    query?: string;
    in_group?: boolean;
    archived?: boolean;
}

/**
 * no description
 */
export class RulesPrivateApi extends runtime.BaseAPI {

    /**
     * Get a list of rules for a specific Environment of a project  You can use query parameters to filter/sort the response. 
     * List Rules
     */
    async listRulesRaw(requestParameters: ListRulesRequest): Promise<runtime.ApiResponse<RulesView>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listRules.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling listRules.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.rule_types !== undefined) {
            queryParameters['rule_types'] = requestParameters.rule_types;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.in_group !== undefined) {
            queryParameters['in_group'] = requestParameters.in_group;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal/projects/{project_id}/environments/{environment_key}/rules`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RulesViewFromJSON(jsonValue));
    }

    /**
     * Get a list of rules for a specific Environment of a project  You can use query parameters to filter/sort the response. 
     * List Rules
     */
    async listRules(requestParameters: ListRulesRequest): Promise<RulesView> {
        const response = await this.listRulesRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListRulesSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc'
}
